module.exports = __webpack_public_path__ + "static/media/export.20ca5164.svg";